
import React, { Fragment, useEffect, useState } from "react";
import { BtnAddTable, BtnCancel, BtnDeleteTable, BtnEditTable, BtnExcelIcon, BtnPDFTable, BtnSearchTable, BtnViewTable, BtnCancelIcon, BtnOKIcon } from "components/Button";
import { AxiosPost, AxiosPostFileExcel } from "utilities/Axios";
import { useLocation, useNavigate } from "react-router-dom";
import { FnBlock_UI } from "components/BlockUI";
import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { AiFillFileExcel } from "react-icons/ai";
import moment from "moment";

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxGroupFormItem } from "components/Input/Checkbox";
import { SelectFormItem } from "components/Input";
import { GetDataAll } from "./CallAPI";

const Report_Excel = (props) => {
    const { nID_Excel, IsOpen, SetIsOpen } = props;

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [open, SetOpen] = useState(IsOpen || false);
    const [ArrDataRegister, SetArrDataRegister] = useState([]);

    const handleClose = () => {
        SetOpen(false);
        SetIsOpen && SetIsOpen(false);
    };

    //#region Form YUP
    const objSchema = yup.object().shape({
        ArrCheckPDF: yupFormSchemas.stringArray("ข้อมูลที่ต้องการออกรายงาน", { required: true }),
        ObjRegisterID: yupFormSchemas.string("ใบสมัครงาน", { required: true })
    });
    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });
    //#endregion

    // useEffect(() => {
    //     onGetDataAll();
    // }, [])

    // const onGetDataAll = () => {
    //     GetDataAll((result) => {
    //         SetArrDataRegister(result.ArrDataRegister ?? []);
    //     });
    // }

    const onExportExcel = async () => {
        BlockUI();
        let param = {
            nID: nID_Excel,
            ArrCheckPDF: form.getValues("ArrCheckPDF"),
            ObjRegisterID: form.getValues("ObjRegisterID"),
        }
        console.log("param > ", param);      
        let fileName = `Excel_${moment().format('yyyyMMDDHHmmss')}.xls`;
        await AxiosPostFileExcel("Report/ExportExcel", param, fileName, () => {
            UnBlockUI();
            handleClose();
        });
    }

    return (
        <Grid>
            <Dialog
                maxWidth={"sm"}
                fullWidth={true}
                open={open}
                onClose={handleClose}
                sx={{ borderRadius: "23px" }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillFileExcel className="bell" /> เลือกข้อมูลที่ต้องการออก Excel</DialogTitle>
                <DialogContent>
                    <Grid item container direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <FormProvider {...form}>
                            <Grid item container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <CheckboxGroupFormItem
                                        name='ArrCheckPDF'
                                        // label='ข้อมูลที่ต้องการออกรายงาน'
                                        required={true}
                                        options={[
                                            { value: "A", label: "ข้อมูลการสมัคร", disabled: true, IsChecked: true },
                                            { value: "B", label: "ประเมินผลของผู้สัมภาษณ์", disabled: false, IsChecked: false },
                                            { value: "C", label: "พิจารณาพนักงาน", disabled: false, IsChecked: false }
                                        ]}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <SelectFormItem
                                        name='ObjRegisterID'
                                        label='ใบสมัครงาน'
                                        fullWidth={true}
                                        required={true}
                                        disabled={false}
                                        options={ArrDataRegister}
                                        isClearable={true}
                                    />
                                </Grid> */}
                            </Grid>
                        </FormProvider>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid marginTop={1} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                        <BtnCancelIcon style={{ width: "130px", marginLeft: "10px" }} onClick={() => { form.reset(); handleClose(); }} />
                        {/* <BtnExcelIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onExportExcel(); })} /> */}
                        <BtnOKIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onExportExcel(); })}/>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default Report_Excel